<template>
    <div>
        <!--<div class="header-return">-->
            <!--<el-row :gutter="20">-->
                <!--<el-col :span="2">-->
                    <!--&lt;!&ndash;<el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>&ndash;&gt;-->
                <!--</el-col>-->
                <!--<el-col :span="2" :offset="22">-->
                    <!--<el-button type="primary" @click="addCrowdProductConfig()" class="header-btn">新建</el-button>-->
                <!--</el-col>-->
            <!--</el-row>-->
        <!--</div>-->
        <el-row :gutter="20">
            <el-table :data="crowdProductList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                      v-show="!showDialog">
                <!--<el-table-column type="index" label="序号" width="50"></el-table-column>-->
                <!--<el-table-column prop="COLLAGE_ID" label="拼单id" v-show="false"></el-table-column>-->
                <!--<el-table-column prop="ACTIVE_NAME" label="活动" width="100"></el-table-column>-->
                <el-table-column prop="activeName" label="众筹活动名称" width="250"></el-table-column>
                <el-table-column prop="proName" label="众筹产品名称" width="250"></el-table-column>
                <el-table-column prop="crowdFundingEntity.targerPeople" label="目标人数" width="80"></el-table-column>
                <el-table-column prop="crowdFundingEntity.crowdPrice" label="众筹价格" width="100"></el-table-column>
                <el-table-column prop="crowdFundingEntity.notice" label="实时话题公告" sortable></el-table-column>
                <el-table-column label="操作" fixed="right" width="350">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editCrowdProductConfig(scope.row)">修改</el-button>
                        <el-button type="primary" size="mini" @click="gotoConfigCoupon(scope.row)">优惠券</el-button>
                        <!--<el-button type="primary" size="mini" @click="gotoConfigDiscount(scope.row)">拼单折扣</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap" v-show="!showDialog">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </el-row>


        <el-dialog title="众筹商品配置" :visible.sync="showDialog">
            <el-form :model="crowdProduct" :rules="rules" label-width="120px">
                <el-form-item label="拼单id" v-show="false">
                    <el-input v-model="crowdProduct.id" placeholder="众筹id"></el-input>
                </el-form-item>
                <el-form-item label="众筹名称" prop="activeNo">
                    <el-select v-model="crowdProduct.activeNo" clearable placeholder="众筹活动">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="众筹商品名称" prop="proId">
                    <el-select v-model="crowdProduct.proId" clearable placeholder="众筹商品名称">
                        <el-option v-for="item in productList"
                                   :key="item.proId"
                                   :label="item.proName"
                                   :value="item.proId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="众筹价格" prop="crowdPrice">
                    <el-input v-model="crowdProduct.crowdPrice" placeholder="众筹价格"></el-input>
                </el-form-item>
                <el-form-item label="目标人数" prop="targerPeople">
                    <el-input v-model="crowdProduct.targerPeople" placeholder="目标人数"></el-input>
                </el-form-item>
                <el-form-item label="虚拟众筹人数" prop="crowdPrice">
                    <el-input v-model="crowdProduct.peopleCount" placeholder="虚拟众筹人数"></el-input>
                </el-form-item>

                <el-form-item label="实时话题公告" prop="notice">
                    <el-input v-model="crowdProduct.notice" placeholder="实时话题公告"></el-input>
                </el-form-item>
                <el-form-item label="投票成功后公告" prop="successNotice">
                    <el-input v-model="crowdProduct.successNotice" placeholder="投票成功后公告"></el-input>
                </el-form-item>
                <el-form-item label="回报说明" prop="paybackDesc">
                    <el-input v-model="crowdProduct.paybackDesc" placeholder="回报说明"></el-input>
                </el-form-item>
                <el-form-item label="拉新奖励金额" prop="newUserAmout">
                    <el-input v-model="crowdProduct.newUserAmout" placeholder="拉新奖励金额"></el-input>
                </el-form-item>
                <el-form-item label="老用户奖励金额" prop="oldUserAmout">
                    <el-input v-model="crowdProduct.oldUserAmout" placeholder="老用户奖励金额"></el-input>
                </el-form-item>
                <el-form-item label="最大奖励金额" prop="maxAmout">
                    <el-input v-model="crowdProduct.maxAmout" placeholder="最大奖励金额"></el-input>
                </el-form-item>
                <el-form-item label="众筹基础金额" prop="baseAmount">
                    <el-input v-model="crowdProduct.baseAmount" placeholder="众筹基础金额"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCrowdProduct()" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getCrowdProductList,
        saveCrowdProductConfig,
        getActiveForOption,
        getProducts
    } from '../../api/api';
    export default {
        data() {
            return {
                loading: false,
                crowdProduct: {
                    id:0,
                    crowdType:1,
                    activeNo:'',
                    notice:'',
                    maxAmout:0,
                    newUserAmout:0,
                    paybackDesc:'',
                    peopleCount:0,
                    proId:'',
                    baseAmount:0,
                    successNotice:'',
                    targerPeople:0
                },
                activeList: [],
                productList: [],
                showDialog: false,
                loading: true,
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                //众筹产品列表
                crowdProductList: [],
                rules: {
                }
            }
        },
        created() {
            this.listCollageShow = true;
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getCrowdProductList();
            this.listCollageShow = true;
            this.getProductList();
            this.getActiveOptionList();
        },
        methods: {
            getCrowdProductList(){
                this.loading = true;
                getCrowdProductList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.crowdProductList = res.data.value.list;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '系统错误，请联系管理员',
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCrowdProductList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCrowdProductList();
            },
            gotoConfigCoupon(row) {
                //跳转配置优惠券
                console.log(row.ACTIVE_NO)
                this.$router.push({path: '/crowdCoupon', query: {activeNo: row.crowdFundingEntity.activeNo, proName: row.proName,proId:row.crowdFundingEntity.proId}})
            },
            editCrowdProductConfig(crowdProduct){
                this.listCollageShow = false;
                this.showDialog = true;

                this.crowdProduct.activeNo = crowdProduct.crowdFundingEntity.activeNo;
                this.crowdProduct.id = crowdProduct.crowdFundingEntity.id;
                this.crowdProduct.notice = crowdProduct.crowdFundingEntity.notice;
                this.crowdProduct.maxAmout = crowdProduct.crowdFundingEntity.maxAmout;
                this.crowdProduct.newUserAmout = crowdProduct.crowdFundingEntity.newUserAmout;
                this.crowdProduct.oldUserAmout = crowdProduct.crowdFundingEntity.oldUserAmout;
                this.crowdProduct.paybackDesc = crowdProduct.crowdFundingEntity.paybackDesc;
                this.crowdProduct.peopleCount = crowdProduct.crowdFundingEntity.peopleCount;
                this.crowdProduct.proId = crowdProduct.crowdFundingEntity.proId;
                this.crowdProduct.crowdPrice = crowdProduct.crowdFundingEntity.crowdPrice;
                this.crowdProduct.successNotice=crowdProduct.crowdFundingEntity.successNotice;
                this.crowdProduct.baseAmount=crowdProduct.crowdFundingEntity.baseAmount;
                this.crowdProduct.targerPeople=crowdProduct.crowdFundingEntity.targerPeople;
            },
            getActiveOptionList(){
                if(this.activeList==undefined||this.activeList.length==0){
                    //查询活动选项
                    getActiveForOption({}).then((res) => {
                        //console.log(res);
                        this.activeList = res.data.value;
                    })
                }
            },
            getProductList(){
                if(this.productList.length==0){
                    //查询产品列表
                    getProducts({}).then((res) => {
                        this.productList = res.data.value;
                    })
                }
            },
            addCrowdProductConfig(){
                //新增众筹商品配置
            },
            saveCrowdProduct(){
                //保存众筹商品配置
                saveCrowdProductConfig(this.crowdProduct).then((res)=>{
                    if (res.data.status == 200){
                        this.$message.success('保存成功');
                        this.showDialog=false;
                        this.getCrowdProductList();
                    }else {
                        this.$message.error('保存失败');
                    }
                });
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/crowd/crowdProduct.vue